import React from "react";
import logoFooter from "../../Assets/LogoFooter.svg";
import instagram from "../../Assets/IG.svg";
import facebook from "../../Assets/FB.svg";
import linkedin from "../../Assets/LinkedIn.svg";
import twitter from "../../Assets/TW.svg";

const Footer = () => {
  return (
    <footer>
      <img src={logoFooter} alt="Possumus"></img>
      <div
        style={{
          borderTop: "1px solid #979797",
          width: "90%",
          margin: "30px auto",
          padding: "30px 0",
        }}
      >
        <a href="https://www.instagram.com/possumus.tech/">
          <img src={instagram} alt="Possumus"></img>
        </a>
        <a href="https://www.facebook.com/possumus.tech/">
          <img
            src={facebook}
            style={{ margin: "0 10px 0 20px" }}
            alt="Possumus"
          ></img>
        </a>
        <a href="https://www.linkedin.com/company/51693692/admin/feed/posts/">
          <img
            src={linkedin}
            style={{ margin: "0 20px 0 10px" }}
            alt="Possumus"
          ></img>
        </a>
        <a href="https://twitter.com/PossumusTech">
          <img src={twitter} alt="Possumus"></img>
        </a>
      </div>
      <div>
        <p
          style={{
            color: "#2E2D31",
            fontSize: "13px",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Copyright © To infinity and beyond. All Rigths Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
